module.exports = __webpack_public_path__ + "img/icon_content_add.7f6bb267.svg";